import { SnackbarProvider } from "notistack";
import { MyLoadingIndicator } from "../components/my-loading-indicator/MyLoadingIndicator";
import { SnackbarUtilsConfigurator } from "../SnackbarUtils";
import { TrainThemeProvider } from "./TrainThemeProvider";

export const TrainLayout = (props) => {
  return (
    <TrainThemeProvider>
      <SnackbarProvider>
        <SnackbarUtilsConfigurator />
        {props.children}
      </SnackbarProvider>
      <MyLoadingIndicator />
    </TrainThemeProvider>
  );
};
